import {PitNavigationService} from "./pit-navigation/services/pit-navigation.service";
import {PitActivitiesMocksProvider} from "./pit-activities/pit-activities-mocks.provider";
import {PitNciMocksProvider} from "./pit-nci/pit-nci-mocks.provider";
import {DxEncryptionService} from "./dx-core/services/dx-encryption.service";
import * as faker from "faker";
import {BdpkTasksMocksProvider} from './bdpk-tasks/bdpk-tasks-mocks.provider';

/** Провайдер моков для всех не lazy-load модулей */
export class AppMocksProvider {

  constructor(private _encryptor: DxEncryptionService) {
    faker.setLocale('ru');
  }

  public static provideAppMocks(): Map<string, any[]> {
    const mocks: Map<string, any[]> = new Map();
    const testUser = {login: 'user', firstName: 'Пользователь', lastName: '1', position: 'Администратор'};
    let str = JSON.stringify(testUser);
    str = encodeURIComponent(str);
    str = unescape(str);
    mocks.set('authenticate', [btoa(str)]);
    mocks.set('top-menu', PitNavigationService.provideTopMenuMocks());
    mocks.set('side-menu', PitNavigationService.provideSideMenuMocks());
    mocks.set('activities-filter-tree', PitActivitiesMocksProvider.provideActivitiesFilterTreeMocks());
    mocks.set('activities-grid-data', PitActivitiesMocksProvider.provideActivitiesGridDataMocks());
    mocks.set('catalogs', PitNciMocksProvider.provideNciMocks()); // <- mock для справочника NCI, метод DxNciService.fetchDictionary()
    //mocks.set('reports-tree', PitActivitiesMocksProvider.provideReportsTreeMocks());
    mocks.set('nci-registry-tree', PitNciMocksProvider.provideNciRegistryTreeMocks());
    // mocks.set('bdpk-tasks', BdpkTasksMocksProvider.provideTasksMocks());
    mocks.set('bdpk-logs', BdpkTasksMocksProvider.provideSchedulerLogsMocks());
    mocks.set('bdpk-schedules', BdpkTasksMocksProvider.provideSchedulesMocks());
    return mocks;
  }
}
